import styled from 'styled-components';

const ProductCard = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  position: relative;

  .no-image-placeholder {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.highlight};
  }

  .product-card__link-to {
    min-height: 0;
    display: flex;
    flex-direction: column;
    text-decoration: none;

    &:hover,
    &:focus {
      .product-card__media img {
        transform: scale(1.04);
      }
    }
  }

  .product-card__media {
    background: ${({ theme }) => theme.colors.highlight};
    transition: background 0.2s ease-out;
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    overflow: hidden;

    img,
    svg {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      max-height: 346px;
      object-fit: contain;
      transition:
        all ease-in-out 0.2s,
        opacity 0.3s ease-out;
      opacity: 0;
    }
    &.loaded-image {
      background: transparent;
      img,
      svg {
        opacity: 1;
      }
    }
  }

  .product-card__details {
    margin-top: 1rem;
    padding-right: 8px;
    padding-left: 8px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: baseline;
  }

  .product-card__eyebrow {
    margin-bottom: 0.875rem;
    color: ${({ theme }) => theme.colors.gray3};
    flex-shrink: 0;

    @media (max-width: 859px) {
      margin-bottom: 1.5rem;
    }
  }

  .product-card__price {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${({ theme }) => theme.colors.brandDark};
  }

  .is-low-quantity {
    color: ${({ themeProps }) => themeProps.color1};
  }

  .product-card__sales {
    display: flex;
    align-self: flex-end;
  }

  .product-card__sale__prev {
    padding-left: ${({ themeProps }) => themeProps.paddingLeft};
    padding-right: ${({ themeProps }) => themeProps.paddingRight};
    margin-right: ${({ themeProps }) => themeProps.marginRight};
    color: ${({ themeProps }) => themeProps.color2};
  }

  .product-card__sale__new {
    color: ${({ theme }) => theme.colors.saleGreen};
  }

  .product-price-with-percentage {
    color: ${({ theme }) => theme.colors.saleGreen};
    align-self: flex-end;
    margin-right: 2px;
  }

  .product-card__title {
    margin-bottom: auto;
    color: ${({ theme }) => theme.colors.brandDark};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    flex-shrink: 0;
    transition: var(--button-transition);
    grid-column-end: span 2;
  }

  .product-card__percent {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.gray3};
    grid-column-end: span 2;
    display: inline-flex;
    flex-wrap: wrap;
  }

  .product-card__percent__node {
    margin-bottom: 0.25rem;
    white-space: nowrap;

    &:first-of-type {
      margin-right: 10px;
    }
  }

  .product-card__options {
    margin-top: auto;
    padding-right: 8px;
    padding-left: 8px;
    display: grid;
    flex-shrink: 0;

    @media (max-width: 859px) {
      padding-top: 1rem;
    }
    @media (min-width: 860px) {
      padding-top: 1.25rem;
    }
  }

  .product-card__option {
    margin-right: auto;
  }

  .product-card__shop {
    margin-top: 1rem;
    padding-right: 8px;
    padding-left: 8px;
    width: 100%;
    display: flex;
    align-items: baseline;
    flex-shrink: 0;
  }

  .product-card__button {
    position: relative;
    width: 100%;
    border-radius: ${({ themeProps }) => themeProps.borderRadius};
    font-family: ${({ themeProps }) => themeProps.font};
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.brandDark};
    color: ${({ theme }) => theme.colors.brandDark};
    font-size: var(--type-scale-14);
    text-align: center;
    flex-shrink: 0;
    transition: all 0.2s;

    @media (max-width: 859px) {
      padding: 0.75rem 28px;
      width: 100%;
    }
    @media (min-width: 860px) {
      margin-right: auto;
      min-width: 5.625rem;
      padding: 0.75rem 16px;
    }

    &:hover {
      outline: none;
      color: ${({ themeProps }) => themeProps.color};
      background-color: ${({ themeProps }) => themeProps.bgColor1};
      border-color: ${({ themeProps }) => themeProps.borderColor1};
    }
    &:focus {
      outline: none;
      color: ${({ themeProps }) => themeProps.color};
      background-color: ${({ themeProps }) => themeProps.bgColor2};
      border-color: ${({ themeProps }) => themeProps.borderColor1};
    }
    &.is-loading {
      .product-card__button__copy {
        opacity: 0;
      }
      &:hover,
      &:focus {
        .product-card__button__load {
          .loading-spinner {
            .path {
              stroke: ${({ theme }) => theme.colors.white};
            }
          }
        }
      }
    }
    &.is-success {
      background-color: ${({ themeProps }) => themeProps.color8};
    }
  }

  .product-card__button__load {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .product-card__badge {
    margin-bottom: 0.25rem;
    display: inline-flex;
    border-radius: 8px;
    letter-spacing: 1px;
    color: ${({ themeProps }) => themeProps.color3};
    line-height: ${({ themeProps }) => themeProps.lineHeight};
    &.is-sativa {
      color: ${({ themeProps }) => themeProps.color4};
    }
    &.is-indica {
      color: ${({ themeProps }) => themeProps.color5};
    }
    &.is-hybrid {
      color: ${({ themeProps }) => themeProps.color6};
    }
    &.is-cbd {
      color: ${({ themeProps }) => themeProps.color7};
    }
  }

  .is-sold-out {
    background-color: ${({ theme }) => theme.colors.gray2};
    border: 1px solid ${({ theme }) => theme.colors.gray2};
    color: ${({ theme }) => theme.colors.white};
    cursor: not-allowed;
    &:hover {
      outline: none;
      background-color: ${({ theme }) => theme.colors.gray2};
      border-color: ${({ theme }) => theme.colors.gray2};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .only-left {
    color: ${({ theme }) => theme.colors.onlyLeftRed};
    font-size: var(--type-scale-12);
    margin: 8px 0 -10px;
    align-self: center;
  }

  .disabled-link {
    pointer-events: none;
  }
`;

export default ProductCard;
